import { Card, CardColors, Text } from '@/ui'
import { getFetchError } from '@/reducers/fetch'
import { useReselector } from '@/utils/sharedHooks'
import { TextColors, TypographyStyles } from '@/styles'

export const CurrentInfoCard = ({
  headerText,
  subheader,
  bottomLeftText,
  bottomRightText,
  insightsFetchKey,
}: {
  headerText?: string | number
  subheader?: string | number
  bottomLeftText?: string | number
  bottomRightText?: string | number
  insightsFetchKey: string
}) => {
  const insightsSummaryError = useReselector(getFetchError, insightsFetchKey)

  if (insightsSummaryError) {
    return (
      <Card
        color={CardColors.LEVEL_1}
        className="h-full p-5 w-full min-h-[149px]"
      >
        <Text variant={TypographyStyles.H2} className="mb-2">
          $ -
        </Text>
        <Text variant={TypographyStyles.BODY_SM} color={TextColors.MUTED}>
          Something went wrong - please try again in a bit.
        </Text>
      </Card>
    )
  }
  return (
    <Card
      color={CardColors.LEVEL_1}
      className="h-full p-5 w-full min-h-[149px]"
    >
      <Text
        variant={TypographyStyles.DISPLAY_LG}
        className="mb-2"
        color={TextColors.BRAND}
      >
        {headerText}
      </Text>
      <Text variant={TypographyStyles.BODY_MD} color={TextColors.MUTED}>
        {subheader}
      </Text>

      {/* Bottom sticky row */}
      <div className="absolute bottom-0 left-0 w-full flex flex-col sm:flex-row justify-between text-muted text-sm pl-6">
        <Text
          className="w-full sm:w-2/3 pl-5 pb-5 text-left"
          variant={TypographyStyles.BODY_SM}
          color={TextColors.MUTED}
        >
          {bottomLeftText}
        </Text>
        <Text
          className="w-full sm:w-1/3 pr-5 pb-5 text-right"
          variant={TypographyStyles.BODY_SM}
          color={TextColors.MUTED}
        >
          {bottomRightText}
        </Text>
      </div>
    </Card>
  )
}
